/**
 * Inbox slice of the English catalog (template-picker carve-out).
 *
 * en.ts sits against the 500-line fileSize ceiling and is the repo's
 * recorded merge hotspot — every parallel branch appends to the same tail.
 * This slice gives inbox vocabulary its own file (spread back into `en` in
 * en.ts, so `t()` and MessageKey are unchanged), the same shape enBoards.ts
 * uses. Add new inbox keys HERE, not in en.ts.
 */
export const enInbox = {
  'inbox.sendTemplate': 'Send approved template',
  'inbox.title': 'Inbox',
  'inbox.subtitleAllChannels':
    'WhatsApp, Instagram, Messenger, and email — reply in one place.',
  'inbox.commentOnPost': 'Comment on a post',
  'inbox.commentReplyPublic': 'Our public reply',
  'inbox.fromNativeApp': 'sent from the app',
  'inbox.replyPublicly': 'Reply publicly under the comment',
  'inbox.replyPrivately': 'Reply in a private message',
  'inbox.commentReplyHint': 'This thread\'s newest message is a public comment.',
  'inbox.templatePickerTitle': 'Send an approved WhatsApp template',
  'inbox.templatePickerSubtitle':
    'Template messages are the only replies WhatsApp delivers outside the 24-hour window.',
  'inbox.templatePickerEmpty': 'No approved templates yet. Create one here or under Account → Integrations → WhatsApp. Meta reviews it, and it appears in this list once approved.',
  'inbox.templatePickerLoading': 'Loading approved templates…',
  'inbox.templateFillValues': 'Fill in the template values',
  'inbox.templateValuePlaceholder': 'Value for {n}',
  'inbox.templatePreview': 'Preview',
  'inbox.templateSendAction': 'Send template',
  'inbox.templateCancel': 'Cancel',
  'inbox.templateClose': 'Close template picker',
  'inbox.draftWithAi': 'Draft a reply with AI',
  'inbox.takeOverNoAiTitle': 'Take over — pause automated replies on this conversation',
  'inbox.selectConversation': 'Select a conversation to start.',
  'inbox.selectConversationTitle': 'Select a conversation',
  'inbox.selectConversationHint':
    'Pick a thread from the list to reply across WhatsApp, Instagram, Messenger, and email in one place.',
  'inbox.channelWhatsapp': 'WhatsApp',
  'inbox.channelInstagram': 'Instagram',
  'inbox.channelMessenger': 'Messenger',
  'inbox.channelEmail': 'Email',
  'inbox.noMessagesYet': 'No messages in this conversation yet.',
  'inbox.agentLabel': 'Agent',
  'inbox.deliveryQueued': 'Queued',
  'inbox.deliverySent': 'Sent',
  'inbox.deliveryDelivered': 'Delivered',
  'inbox.deliveryRead': 'Read',
  'inbox.deliveryFailed': 'Failed',
  'inbox.sendMessage': 'Send message',
  'inbox.composerAriaLabel': 'Message reply',
  'inbox.composerEmpty': 'Message cannot be empty.',
  'inbox.composerTooLong': 'Message is too long (max {max} characters).',
  'inbox.composerWindowClosedPlaceholder': 'Free-form replies are disabled outside the 24-hour window',
  'inbox.composerReplyPlaceholder': 'Reply to {name}…',
  'inbox.retryLoad': 'Try again',
  'inbox.loadMore': 'Load more conversations',
  'inbox.searchPlaceholder': 'Search conversations…',
  'inbox.searchAria': 'Search conversations',
  'inbox.filterAll': 'All',
  'inbox.filterAi': 'AI handling',
  'inbox.filterNeedsReply': 'Needs reply',
  'inbox.filterResolved': 'Resolved',
  'inbox.emptyConversations':
    'No conversations yet. Incoming WhatsApp / Instagram / Messenger messages will appear here in real time.',
  'inbox.emptyFilter': 'No conversations match this filter.',
  'inbox.unread': 'Unread',
  'inbox.negativeSentiment': 'Negative',
  'inbox.tagVip': 'VIP',
  'inbox.tagAi': 'AI',
} as const;
